import s from '../../styles/components/story/Culture.module.css';

export default function Culture({ data }) {
  const { label, headline, values } = data;

  return (
    <section className={s.section}>
      <div className={s.inner}>
        {label && <span className={s.label}>{label}</span>}
        <h2 className={s.headline}>{headline}</h2>
        <div className={s.list}>
          {values.map((value) => (
            <div key={value.id} className={s.row}>
              <span className={s.number}>{String(value.id).padStart(2, '0')}</span>
              <div className={s.text}>
                <h3 className={s.valueTitle}>{value.title}</h3>
                <p className={s.valueBody}>{value.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}